// Route wrapper: filter is a URL search param (?filter=) so it's linkable/
// refresh-safe; FleetList itself stays router-free (props only) so its unit
// tests need no router.
import { useNavigate, useSearch } from '@tanstack/react-router';
import { FleetList, type FleetFilter } from './FleetList';

export function FleetRoute() {
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { filter?: FleetFilter };
  return (
    <FleetList
      onOpenSite={(siteId) =>
        void navigate({ to: '/sites/$siteId/$tab', params: { siteId, tab: 'status' } })
      }
      filter={search.filter}
      onFilterChange={(filter) =>
        // 'all' is the default — drop it from the URL instead of pinning ?filter=all.
        void navigate({ to: '/', search: filter === 'all' ? {} : { filter } })
      }
    />
  );
}
